import { useState } from 'react';
import { useCostTabStore, useStrategyStore } from '../../../../../../store/strategy-store/strategy-store';
import { Panel } from '../../../../../../store/strategy-store/strategy-store.type';
import { baseWhite, secondaryBase } from '../../../../../../styles/design-tokens';
import { ChartDataType, CostMode } from '../../cost-tab.type';
import { LINE_SPACING, STROKE_WIDTH, TEXT_PADDING } from './tree-map-content.constants';
import {
  calculateFontSize,
  calculateMaxLines,
  calculateStartY,
  shouldRenderText,
  wrapText,
} from './tree-map-content.helpers';

// Custom content component to display inside the treemap cells
// Using any for props to match Recharts expectations
export const TreeMapContent = (props: any) => {
  const { title, x, y, width, height, fill, id, type } = props;
  const [isHovered, setIsHovered] = useState(false);

  const selectedEpic = useCostTabStore((state) => state.selectedEpic);
  const selectedTeam = useCostTabStore((state) => state.selectedTeam);
  const mode = useCostTabStore((state) => state.mode);
  const performanceActivePanel = useStrategyStore((state) => state.performanceActivePanel);

  const isEpicSelected = mode === CostMode.ContributingEpics && selectedEpic?.id === id;
  const isTeamSelected = mode === CostMode.ContributingTeams && selectedTeam?.id === id;
  const isOtherEpicsSelected = type === ChartDataType.Other && performanceActivePanel === Panel.OtherEpics;
  const isOtherTeamsSelected = type === ChartDataType.Other && performanceActivePanel === Panel.OtherTeams;
  const isSelected = isEpicSelected || isTeamSelected || isOtherEpicsSelected || isOtherTeamsSelected;

  const canRenderText = shouldRenderText(width, height);
  const fontSize = calculateFontSize(width);

  // Get wrapped text lines
  const textLines = canRenderText ? wrapText(title || '', width - TEXT_PADDING, fontSize) : [];
  const maxLines = calculateMaxLines(height, fontSize);
  const displayLines = textLines.slice(0, maxLines);

  // Calculate starting Y position for centered text
  const startY = calculateStartY(y, height, displayLines.length, fontSize);

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          fill: isHovered || isSelected ? secondaryBase : fill,
          stroke: baseWhite,
          strokeWidth: STROKE_WIDTH,
          cursor: 'pointer',
        }}
      />
      {canRenderText && Array.isArray(displayLines) && displayLines.length > 0 && (
        <text
          x={x + width / 2}
          y={startY}
          textAnchor="middle"
          fontSize={fontSize}
          fill={baseWhite}
          style={{
            pointerEvents: 'none',
            fontFamily: 'Figtree',
            fontWeight: 500,
          }}
        >
          {displayLines.map((line, index) => (
            <tspan key={index} x={x + width / 2} dy={index === 0 ? 0 : fontSize + LINE_SPACING}>
              {line}
              {index === displayLines.length - 1 && textLines.length > maxLines && '...'}
            </tspan>
          ))}
        </text>
      )}
    </g>
  );
};
